import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import autoBind from 'react-autobind';
import classnames from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';

import FormError from 'ui/common/form/form-error';
import { withApollo } from 'react-apollo';
import TextField from 'ui/common/form/fields/text-field';
import ImageEditorField from 'ui/common/form/fields/image-editor-field';
import validator from 'ui/common/form/validator';
// import LocalMultiAutoCompleteField from 'ui/common/form/fields/local-multi-auto-complete-field';

import fields, { fieldNames, socialLinkModel } from './model';
import * as messages from './messages';
import {
  selectCurrentUser,
  selectCurrentUsername,
  selectCurrentUserHasAutoGeneratedUsername,
} from 'store/features/auth/selectors';
import { updateCurrentUser } from 'store/features/auth/actions';
import { addMessage } from 'store/features/common/flash/actions';
// import SimpleSelect from 'ui/common/form/fields/simple-select-field';

export const FORM_NAME = 'update-basic-info-form';
// const usernamePrefix = 'https://indorse.io/';
const rootValidator = validator(fields);

function validate(values) {
  let errors = rootValidator(values) || {};
  errors[fieldNames.socialLinks] = (values[fieldNames.socialLinks] || []).map(socialLink =>
    validator(socialLinkModel(socialLink ? socialLink.type : null))(socialLink)
  );
  return errors;
}

class BasicInfoForm extends Component {
  constructor(props) {
    super(props);

    autoBind(this);
  }

  render() {
    const {
      currentUserImageUrl,
      className,
      handleSubmit,
      form: formName,
      intl: { formatMessage },
    } = this.props;

    return (
      <div className={className}>
        <form title={formatMessage(messages.header.title)} onSubmit={handleSubmit}>
          <div className={classnames('row align-items-center')}>
            <div className="col-7 mx-auto">
              <FormError formName={formName} />
              <div className="p-3">
                <center>
                  <Field
                    name={fieldNames.img}
                    component={ImageEditorField}
                    label={formatMessage(messages.labels.img)}
                    className="pt-3"
                    defaultPreviewSrc={currentUserImageUrl}
                    previewProps={{
                      editorHeight: 160,
                      editorWidth: 160,
                      borderRadius: 160,
                    }}
                  />
                </center>
              </div>
            </div>
            <div className="col-7 mx-auto">
              <div className="px-3">
                <span>{formatMessage(messages.labels.name)}</span>
                <Field name={fieldNames.name} component={TextField} />
              </div>
              <div className="px-3">
                <Field
                  name={fieldNames.bio}
                  component={TextField}
                  label={formatMessage(messages.labels.bio)}
                  multiLine
                  rows={3}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const currentUser = selectCurrentUser(state);
  const currentUserUsername = selectCurrentUsername(state);
  const currentUserHasAutoGeneratedUsername = selectCurrentUserHasAutoGeneratedUsername(state);
  const {
    name,
    bio,
    imgUrl,
    position,
    yearsOfExperience,
    employmentStatus,
    aggregateExperience,
  } = currentUser;

  const originalOnSubmit = ownProps ? ownProps.onSubmit : null;
  let onSubmit = originalOnSubmit;

  if (originalOnSubmit) {
    const modalSubmit = values => {
      if (currentUserUsername) delete values[fieldNames.username];

      originalOnSubmit(values);
    };

    onSubmit = modalSubmit;
  }

  return {
    initialValues: {
      name,
      bio,
      img: imgUrl,
      position,
      yearsOfExperience: (yearsOfExperience || '').toString(), // VERY IMPORTANT, don't revert back to number
      employmentStatus,
      aggregateExperience,
    },
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    currentUserUsername,
    currentUserHasAutoGeneratedUsername,
    currentUserImageUrl: imgUrl,
    onSubmit,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    addMessage: bindActionCreators(addMessage, dispatch),
    updateCurrentUser: {
      request: bindActionCreators(updateCurrentUser.request, dispatch),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: FORM_NAME,
    validate,
  })(injectIntl(withApollo(BasicInfoForm)))
);



// WEBPACK FOOTER //
// ./src/ui/graphql/UpdateBasicInfo/form.js